import React, { useState, useEffect } from "react";
import { LoadButtonBlock } from "./styled";
import { Heading, Text } from "../../../styled";
import AnimatedDots from "../AnimatedDots/AnimatedDots";

const LoadButton = ({ loadingArray, loadingTextArray, action }) => {
  const [loadingPercent, setLoadingPercent] = useState(0);

  useEffect(() => {
    incrementPercent();
  }, []);

  useEffect(() => {
    setProcess();
  }, [loadingPercent]);

  const setText = () => {
    if (loadingPercent === 100) {
      return "Next";
    }
    return `${loadingPercent}%`;
  };

  const setProcess = () => {
    let text;
    loadingTextArray.find((item) => {
      if (
        loadingPercent > item.startPercent &&
        loadingPercent < item.finishPercent
      ) {
        text = item.text;
      }
    });
    return text ? (
      <span>
        {text}
        <AnimatedDots />
      </span>
    ) : (
      ""
    );
  };

  const incrementPercent = () => {
    let percent = loadingPercent;
    let curStep = 0;
    const totalSteps = loadingArray.length - 1;

    const next = () => {
      render();
    };

    const render = () => {
      if (percent < loadingArray[curStep].finish) {
        let int = setInterval(() => {
          percent++;
          setLoadingPercent(percent);
          if (percent >= loadingArray[curStep].finish) {
            clearInterval(int);
            if (curStep < totalSteps) {
              curStep++;
            }
            next();
          }
        }, loadingArray[curStep].timeout);
      }
    };
    next();
  };

  const handleButtonClick = () => {
    if (loadingPercent === 100) {
      action();
    }
  };

  return (
    <LoadButtonBlock.Wrapper>
      <LoadButtonBlock.Process>
        <Text.Process style={{ height: 20 }}>{setProcess()}</Text.Process>
      </LoadButtonBlock.Process>
      <LoadButtonBlock onClick={handleButtonClick}>
        <LoadButtonBlock.Line style={{ width: `${loadingPercent}%` }} />
        <LoadButtonBlock.Text>
          <Heading.Second>{setText()}</Heading.Second>
        </LoadButtonBlock.Text>
      </LoadButtonBlock>
    </LoadButtonBlock.Wrapper>
  );
};

export default LoadButton;
